/**
 * PROPOSITION.MODEL.TS
 * Multiple choice response
 */

//Sentinel note value used locally (redux) so the "non concerné" button can show as selected —
//distinct from null (item never touched) purely for UI purposes. Converted back to null by
//backend-ts before writing to fact_notes.value (same DB treatment as question-level NSPP).
export const NOT_CONCERNED_NOTE = -1

export class Proposition{
  active:boolean = false
  aid:number = 0
  attributeAid:number = 0
  attributeId:string = ""
  id:string = ""
  name:any = {}
  special:string | null = null
  valueSpecial:number | null = null
  order:number | null = null
  note:number | null = null
  
  constructor(proposition: Partial<Proposition> = {}){
    Object.assign(this, proposition)
  }

}